// extracted by mini-css-extract-plugin
export var divider = "_m8-0";
export var systemMessage = "_m8-1";
export var systemMessageWrapper = "_m8-2";